import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { VisuallyHidden } from '@chakra-ui/react';
import { GET_STATIC_CONTENT, SITE_LEISURE } from '@whitbread-eos/api';
import { useCustomLocale, useQueryRequest } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';
import HeaderVariantDefault from './HeaderVariantDefault';
import HeaderVariantLogo from './HeaderVariantLogo';
import HeaderVariantStepContainer from './HeaderVariantStep/HeaderVariantStep.container';
import { jsx as _jsx } from "react/jsx-runtime";
export default function HeaderLeisure(_ref) {
  var variant = _ref.variant,
    isIcon = _ref.isIcon,
    queryClient = _ref.queryClient,
    _ref$bb = _ref.bb,
    bb = _ref$bb === void 0 ? false : _ref$bb,
    useNextImage = _ref.useNextImage;
  var _useCustomLocale = useCustomLocale(),
    currentLanguage = _useCustomLocale.language,
    currentCountry = _useCustomLocale.country;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useQueryRequest = useQueryRequest(['GetStaticContent', currentLanguage, currentCountry], GET_STATIC_CONTENT, {
      language: currentLanguage,
      country: currentCountry,
      site: SITE_LEISURE,
      businessBooker: false
    }),
    data = _useQueryRequest.data,
    isLoading = _useQueryRequest.isLoading;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    headerInfoData = _useState2[0],
    setHeaderInfoData = _useState2[1];
  useEffect(() => {
    var _data$headerInformati;
    if (data !== null && data !== void 0 && (_data$headerInformati = data.headerInformation) !== null && _data$headerInformati !== void 0 && (_data$headerInformati = _data$headerInformati.content) !== null && _data$headerInformati !== void 0 && (_data$headerInformati = _data$headerInformati.countries) !== null && _data$headerInformati !== void 0 && _data$headerInformati.length) {
      setHeaderInfoData(data === null || data === void 0 ? void 0 : data.headerInformation);
    }
  }, [data === null || data === void 0 ? void 0 : data.headerInformation]);
  if (isLoading) {
    return _jsx(VisuallyHidden, {
      children: t('searchresults.list.hotel.loading')
    });
  }
  if (currentLanguage === 'de') {
    return renderHeader(headerInfoData, variant, bb, queryClient, isIcon, 'pi-simple', useNextImage);
  }
  return renderHeader(headerInfoData, variant, bb, queryClient, isIcon, undefined, useNextImage);
}
function renderHeader(headerInfoData, variant, bb, queryClient) {
  var isIcon = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var hotelBrand = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'pi';
  var useNextImage = arguments.length > 6 ? arguments[6] : undefined;
  switch (variant) {
    case 'default':
      {
        return _jsx(HeaderVariantDefault, {
          headerInfoData: headerInfoData,
          hotelBrand: hotelBrand,
          useNextImage: useNextImage
        });
      }
    case 'step':
      {
        return _jsx(HeaderVariantStepContainer, {
          headerInfoData: headerInfoData,
          bb: bb,
          queryClient: queryClient
        });
      }
    case 'logo':
      {
        return _jsx(HeaderVariantLogo, {
          headerInfoData: headerInfoData,
          hotelBrand: hotelBrand,
          isIcon: isIcon,
          bb: bb
        });
      }
    default:
      {
        return _jsx(HeaderVariantDefault, {
          headerInfoData: headerInfoData,
          hotelBrand: hotelBrand
        });
      }
  }
}